<template>
  <div class="introduce">
    <div class="introduce-iner">
      <p class="introduce-iner-title">股宇宙数据库</p>
      <p
        class="introduce-iner-cont"
      >股宇宙数据库专家团历经1000多个日夜，研发出了新一代证券数据超算智库--股宇宙数据库，体现的超算数据重点，紧跟市场脉搏，用数据智能模型重新定义投资数据的重要性，以模型数据涌现的新认知，引领用户新认识，帮助提升“最佳结果”，以数之本，驭富之果。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "introduceGYZ"
}
</script>

<style scoped>
.introduce {
  width: 100%;
  height: 483px;
  background-color: #f3f5f9;
  padding-top: 146px;
  box-sizing: border-box;
}
.introduce .introduce-iner {
  width: var(--content-width);
  min-width: var(--content-min-width);
  margin: auto;
  padding: 0 20px;
  box-sizing: border-box;
}
.introduce .introduce-iner .introduce-iner-title {
  text-align: center;
  padding-bottom: 33px;
  width: 100%;
  font-weight: 800;
  font-size: 45px;
  color: #1a1a1a;
}
.introduce .introduce-iner .introduce-iner-cont {
  text-align: left;
  font-weight: 500;
  font-size: 21px;
  color: #4d4d4d;
  line-height: 33px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/IntroduceGYZ.vue